import * as unidade from '@/api/unidade'
import { convertSelect } from '../../../service/collection'

const state = {
  list: [],
  listAssinaturas: [],
  pacotes: [],
  listaSelect: [],
  unidadesAcesso: [],
  filtros: {nome: '', grupo: '', page: 1},
  filtrosPacote: {page: 1},
  filtrosAssinaturas: { page: 1 },
  countPage: 0,
  countPagePacote: 0,
  countPageAssinaturas: 0,
  modalAddUnidade: false,
  modalEditUnidade: false,
  modalDelUnidade: false,
  modalAddPacote: false,
  modalConfDelUnidade: false,
  modalConfPacote: false,
  modalConfirmaDesativacao: false,
  modalEditAssinatura: false,
  modalCancelaAssinatura: false,
  modalAtivarAssinatura: false,
  modalConfirmarAssinatura: false,
  modalBonificar: false,
  modalCancelarBoleto: false,
  modalConfPagarBoleto: false
}

const mutations = {
  SETUNIDADES (state, payload) {
    state.list = payload.list
  },
  SETPACOTES (state, payload) {
    state.pacotes = payload
  },
  SETUNIDADESASSINATURAS (state, payload) {
    state.listAssinaturas = payload.list
  },
  HIDDEMODAL (state) {
    state.modalAddUnidade = false
    state.modalEditUnidade = false
    state.modalConfDelUnidade = false
    state.modalAddPacote = false
    state.modalConfPacote = false
  },
  MODALADDUNIDADE (state) {
    state.modalAddUnidade = !state.modalAddUnidade
  },
  MODALEDITUNIDADE (state) {
    state.modalEditUnidade = !state.modalEditUnidade
  },
  MODALADDPACOTE (state) {
    state.modalAddPacote = !state.modalAddPacote
  },
  MODALCONFIRMAPACOTE (state) {
    state.modalConfPacote = !state.modalConfPacote
  },
  MODALCONFDELUNIDADE (state) {
    state.modalConfDelUnidade = !state.modalConfDelUnidade
  },
  SETUNIDADESSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.list)
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGEPACOTES (state, payload) {
    state.filtrosPacote.page = payload
  },
  SETPAGEASSINATURAS (state, payload) {
    state.filtrosAssinaturas.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETPAGINATEPACOTES (state, payload) {
    if (payload === 1) state.countPagePacote = 0
    else state.countPagePacote = payload
  },
  SETPAGINATEASSINATURAS (state, payload) {
    if (payload === 1) state.countPageAssinaturas = 0
    else state.countPageAssinaturas = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETFILTROSPACOTES (state, payload) {
    if (payload) {
      state.filtrosPacote = payload
    }
  },
  SETFILTROSASSINATURAS (state, payload) {
    if (payload) {
      state.filtrosAssinaturas = payload
    }
  },
  SETUNIDADESACESSO (state, payload) {
    state.unidadesAcesso = payload
  },
  SETLIMPARSELECT (state) {
    state.listaSelect = []
  },
  MODALCONFIRMADESATIVACAO (state, payload) {
    state.modalConfirmaDesativacao = payload
  },
  MODALEDITASSINATURA (state, payload) {
    state.modalEditAssinatura = payload
  },
  MODALCANCELARASSINATURA (state, payload) {
    state.modalCancelaAssinatura = payload
  },
  MODALCANCELARBOLETO (state, payload) {
    state.modalCancelarBoleto = payload
  },
  MODALATIVARASSINATURA (state, payload) {
    state.modalAtivarAssinatura = payload
  },
  MODALCONFIRMARASSINATURA (state, payload) {
    state.modalConfirmarAssinatura = payload
  },
  MODALBONIFICAR (state, payload) {
    state.modalBonificar = payload
  },
  MODALCONFPAGARBOLETO (state, payload) {
    state.modalConfPagarBoleto = payload
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAddUnidade: function ({ commit }) {
    commit('MODALADDUNIDADE')
  },
  modalEditUnidade: function ({ commit }) {
    commit('MODALEDITUNIDADE')
  },
  modalAddPacote: function ({ commit }) {
    commit('MODALADDPACOTE')
  },
  modalConfDelUnidade: function ({ commit }) {
    commit('MODALCONFDELUNIDADE')
  },
  modalConfirmaPacote: function ({ commit }) {
    commit('MODALCONFIRMAPACOTE')
  },
  async get ({ commit }, payload) {
    let data = await unidade.get(payload)
    return data
  },
  async getUnidades ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await unidade.getUnidades(payload)
    commit('SETUNIDADES', data)
    commit('SETPAGINATE', data.pages)
  },
  async getUnidadesUsuarios ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await unidade.getUnidadesUsuarios(payload)
    commit('SETUNIDADES', data)
    commit('SETPAGINATE', data.pages)
  },
  async getUnidadesAssinaturas ({ commit }, payload) {
    commit('SETFILTROSASSINATURAS', payload)
    let data = await unidade.getUnidadesAssinaturas(payload)
    commit('SETUNIDADESASSINATURAS', data.instancia)
    commit('SETPAGINATEASSINATURAS', data.instancia.pages)
  },
  async getUnidadesAssinaturasFiltro ({ commit, dispatch }) {
    let data = await unidade.getUnidadesAssinaturas(state.filtrosAssinaturas)
    if (state.filtros.page > data.instancia.pages) dispatch('setPage', data.instancia.pages)
    else {
      commit('SETUNIDADESASSINATURAS', data.instancia)
      commit('SETPAGINATEASSINATURAS', data.instancia.pages)
    }
  },
  async getUnidadesFiltro ({ commit, dispatch }) {
    let data = await unidade.getUnidades(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETUNIDADES', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async getUnidadesSelect ({ commit }, payload) {
    let data = await unidade.getUnidadesSelect(payload)
    commit('SETUNIDADESSELECT', data)
  },
  async getUnidadesSelectSemCommit ({ commit }, payload) {
    let data = await unidade.getUnidadesSelect(payload)
    return convertSelect(data.list)
  },
  async add ({ commit }, payload) {
    if (payload.unidade) {
      payload.unidade.id = payload.unidade.value
    }
    payload.cidade.id = payload.cidade.value
    try {
      let reg = await unidade.add(payload)
      return reg
    } catch (e) {
      return e
    }
  },
  async edit ({ commit }, payload) {
    if (payload.unidade) payload.unidade.id = payload.unidade.value
    if (payload.cidade) payload.cidade.id = payload.cidade.value
    if (payload.vendedor) payload.vendedor.id = payload.vendedor.value

    return unidade.edit(payload)
  },
  async editLimite ({ commit }, payload) {
    if (payload.unidade) payload.unidade.id = payload.unidade.value

    return unidade.editLimite(payload)
  },
  async delUnidade ({ commit }, payload) {
    try {
      let retorno = await unidade.delUnidade(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async delUnidadeMaster ({ commit }, payload) {
    try {
      let retorno = await unidade.delUnidadeMaster(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async addPacote ({ commit }, payload) {
    try {
      payload.unidade.id = payload.unidade.value
      for (let p = 0; p < payload.tipos.length; p++) {
        payload.tipos[p].id = payload.tipos[p].value
      }
      let retorno = await unidade.addPacote(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async getPacotes ({ commit }, payload) {
    commit('SETFILTROSPACOTES', payload)
    let data = await unidade.pacotes(payload)
    commit('SETPACOTES', data)
    commit('SETPAGINATEPACOTES', data.pages)
  },
  async getPacotesFiltro ({ commit, dispatch }) {
    let data = await unidade.pacotes(state.filtrosPacote)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETPACOTES', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async inativaPacote ({ commit }, payload) {
    try {
      await unidade.inativaPacote(payload)
      return true
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getUnidades', state.filtros)
  },
  setPageUU (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getUnidadesUsuarios', state.filtros)
  },
  setPageAssinaturas (context, payload) {
    context.commit('SETPAGEASSINATURAS', payload)
    context.dispatch('getUnidadesAssinaturas', state.filtrosAssinaturas)
  },
  setPagePacotes (context, payload) {
    context.commit('SETPAGEPACOTES', payload)
    context.dispatch('getPacotes', state.filtrosPacote)
  },
  async listUnidadesAcesso ({ commit }) {
    let unidades = await unidade.listUnidadesAcesso()
    commit('SETUNIDADESACESSO', unidades)
  },
  async getUnidadeFoco (context, payload) {
    return unidade.getUnidadeFoco()
  },
  async getUnidadesTotalUsuarios (context, payload) {
    let unidades = await unidade.getUnidadesTotalUsuarios(payload)
    return unidades.instancia
  },
  async getUnidadesTotalUsuariosPorVendedor (context, payload) {
    let unidades = await unidade.getUnidadesTotalUsuariosPorVendedor(payload)
    return unidades.instancia
  },
  limparSelect ({commit}) {
    commit('SETLIMPARSELECT')
  },
  modalConfirmaDesativacao: function ({ commit }, payload) {
    commit('MODALCONFIRMADESATIVACAO', payload)
  },
  async alteraStatusUnidade ({ commit }, payload) {
    let reg = await unidade.alteraStatusUnidade(payload)
    return reg
  },
  async getUnidadesSelectRelatorioSemCommit ({ commit }, payload) {
    let data = await unidade.getUnidadesRelatorioSelect(payload)
    return convertSelect(data.list)
  },
  modalEditAssinatura: function ({ commit }, payload) {
    commit('MODALEDITASSINATURA', payload)
  },
  async getAssinatura ({ commit }, payload) {
    let data = await unidade.getAssinatura(payload)
    if (!data.instancia.assinatura) {
      data.instancia.assinatura = {
        planos_assinaturas: {},
        proximo_vencimento: '',
        nao_cobrar: false
      }
    } else if (!data.instancia.assinatura.planos_assinaturas) data.instancia.assinatura.planos_assinaturas = {}
    return data.instancia
  },
  async calculaPlano ({ commit }, payload) {
    try {
      return unidade.getCalculaPlano(payload)
    } catch (e) {
      return e
    }
  },
  async calculaUsuariosAdicionais ({ commit }, payload) {
    try {
      return unidade.getcalculaUsuariosAdicionais(payload)
    } catch (e) {
      return e
    }
  },
  async calculaUsuariosAdicionaisPlanoControle ({ commit }, payload) {
    try {
      return unidade.getcalculaUsuariosAdicionaisPlanoControle(payload)
    } catch (e) {
      return e
    }
  },
  async geraFaturaUsuarios ({ commit }, payload) {
    try {
      return unidade.geraFaturaUsuarios(payload)
    } catch (e) {
      return e
    }
  },
  async geraFaturaUsuariosPlanoControle ({ commit }, payload) {
    try {
      return unidade.geraFaturaUsuariosPlanoControle(payload)
    } catch (e) {
      return e
    }
  },
  async geraFaturaAvulsa ({ commit }, payload) {
    try {
      return unidade.geraFaturaAvulsa(payload)
    } catch (e) {
      return e
    }
  },
  async saveAssinatura ({ commit }, payload) {
    try {
      return unidade.saveAssinatura(payload)
    } catch (e) {
      return e
    }
  },
  async saveAssinaturaTeste ({ commit }, payload) {
    try {
      return unidade.saveAssinaturaTeste(payload)
    } catch (e) {
      return e
    }
  },
  modalCancelarAssinatura: function ({ commit }, payload) {
    commit('MODALCANCELARASSINATURA', payload)
  },
  modalCancelarBoleto: function ({ commit }, payload) {
    commit('MODALCANCELARBOLETO', payload)
  },
  modalAtivarAssinatura: function ({ commit }, payload) {
    commit('MODALATIVARASSINATURA', payload)
  },
  modalConfirmarAssinatura: function ({ commit }, payload) {
    commit('MODALCONFIRMARASSINATURA', payload)
  },
  cancelaAssinatura: async function ({ commit }, payload) {
    try {
      return unidade.cancelaAssinatura(payload)
    } catch (e) {
      return e
    }
  },
  ativarAssinaturaComprovante: async function ({ commit }, payload) {
    try {
      return unidade.ativarAssinaturaComprovante(payload)
    } catch (e) {
      return e
    }
  },
  modalBonificar: function ({ commit }, payload) {
    commit('MODALBONIFICAR', payload)
  },
  async saveAssinaturaControle ({commit}, payload) {
    return unidade.saveAssinaturaControle(payload)
  },
  modalConfPagarBoleto: function ({ commit }, payload) {
    commit('MODALCONFPAGARBOLETO', payload)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/unidade.js